<form class="flex flex-col gap-3 mb-4" [formGroup]="form">
  <div class="flex flex-wrap items-center gap-3">
    <mat-form-field class="w-64" subscriptSizing="dynamic">
      <mat-label>Search</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput formControlName="search" placeholder="Name, email..." />
    </mat-form-field>

    @if (companyData().options.length) {
      <mat-form-field class="w-48" subscriptSizing="dynamic">
        <mat-label>Company</mat-label>
        <mat-select multiple formControlName="companies">
          @for (company of companyData().options; track company) {
            <mat-option [value]="company">{{ company }} ({{ companyData().counts.get(company) }})</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (jobTitleData().options.length) {
      <mat-form-field class="w-48" subscriptSizing="dynamic">
        <mat-label>Job title</mat-label>
        <mat-select multiple formControlName="jobTitles">
          @for (jobTitle of jobTitleData().options; track jobTitle) {
            <mat-option [value]="jobTitle">{{ jobTitle }} ({{ jobTitleData().counts.get(jobTitle) }})</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-slide-toggle formControlName="currentJobOnly">Current job only</mat-slide-toggle>
  </div>

  <div class="flex flex-wrap items-center gap-3">
    @if (countryData().options.length) {
      <mat-form-field class="w-48" subscriptSizing="dynamic">
        <mat-label>Country</mat-label>
        <mat-select multiple formControlName="countries">
          @for (country of countryData().options; track country) {
            <mat-option [value]="country">{{ country }} ({{ countryData().counts.get(country) }})</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field class="w-40" subscriptSizing="dynamic">
      <mat-label>MVP type</mat-label>
      <mat-select multiple formControlName="types">
        @for (type of typeData().options; track type) {
          <mat-option [value]="type" [matTooltip]="type | mvpExpertTypeTooltip"
            >{{ type | mvpExpertType }} ({{ typeData().counts.get(type) ?? 0 }})</mat-option
          >
        }
      </mat-select>
    </mat-form-field>

    @if (ownerData().options.length) {
      <mat-form-field class="w-48" subscriptSizing="dynamic">
        <mat-label>Expert owner</mat-label>
        <mat-select multiple formControlName="ownerConnectIds">
          @for (owner of ownerData().options; track owner.id) {
            <mat-option [value]="owner.id">{{ owner.label }} ({{ ownerData().counts.get(owner.id) }})</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (segmentData().options.length) {
      <mat-form-field class="w-56" subscriptSizing="dynamic">
        <mat-label>Opportunity segment</mat-label>
        <mat-select multiple formControlName="opportunitySegmentIds">
          @for (segment of segmentData().options; track segment.id) {
            <mat-option [value]="segment.id"
              >{{ segment.label }} ({{ segmentData().counts.get(segment.id) }})</mat-option
            >
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field class="w-56" subscriptSizing="dynamic">
      <mat-label>Progression</mat-label>
      <mat-select multiple formControlName="progressions">
        @for (progression of progressionData().options; track progression) {
          <mat-option [value]="progression"
            >{{ progression | titlecase }} ({{ progressionData().counts.get(progression) ?? 0 }})</mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-wrap items-center gap-3">
    @if (showHonorariaFilter()) {
      <mat-form-field class="w-48" subscriptSizing="dynamic">
        <mat-label>Honoraria currency</mat-label>
        <mat-select formControlName="honorariaCurrency">
          <mat-option [value]="null">Any</mat-option>
          @for (currency of currencyData(); track currency) {
            <mat-option [value]="currency">{{ currency }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-36" subscriptSizing="dynamic">
        <mat-label>Operator</mat-label>
        <mat-select formControlName="honorariaOperator">
          <mat-option [value]="null">—</mat-option>
          @for (op of operatorOptions; track op.value) {
            <mat-option [value]="op.value">{{ op.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-48" subscriptSizing="dynamic">
        <mat-label>Honoraria amount</mat-label>
        <input matInput type="number" min="0" formControlName="honorariaAmount" placeholder="e.g. 500" />
      </mat-form-field>
    }
  </div>
</form>
